import React, { useState } from 'react';
import AddEditForm from './form';
import ViewList from './view';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';
import { Type, Plus } from 'lucide-react';

const AttributesTypes = () => {
  const [selectedAttribute, setSelectedAttribute] = useState(null);

  const handleEdit = attribute => {
    setSelectedAttribute(attribute);
  };

  const handleFormSubmit = data => {
    setSelectedAttribute(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center">
              <Type className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                Product Attributes
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Define product attributes and their values for better
                organization
              </p>
            </div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Add/Edit Form */}
          <Card className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border border-white/20 dark:border-gray-700/50 col-span-4">
            <CardHeader className="border-b border-gray-100 dark:border-gray-700">
              <CardTitle className="flex items-center space-x-2 text-lg">
                <div className="w-2 h-2 bg-gradient-to-r from-orange-500 to-red-500 rounded-full"></div>
                <span>Attribute Management</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <AddEditForm
                selectedAttribute={selectedAttribute}
                onFormSubmit={handleFormSubmit}
              />
            </CardContent>
          </Card>

          {/* Attributes List */}
          <Card className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border border-white/20 dark:border-gray-700/50 col-span-8">
            <CardHeader className="border-b border-gray-100 dark:border-gray-700">
              <CardTitle className="flex items-center space-x-2 text-lg">
                <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-full"></div>
                <span>Existing Attributes</span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <ViewList onEdit={handleEdit} />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AttributesTypes;
